import React, { useContext, useState, useEffect } from "react";
import {
  Box,
  Button,
  Heading,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  HStack,
  useToast,
  useRadioGroup,
  Text,
  Flex,
  Divider,
  Select,
} from "@chakra-ui/react";
import { HomeContext } from "../../../context/HomeContext";
import IconCard from "../../layouts/IconCard";
import Counter from "../../../assets/Counter";
import Picto1 from "./picto3/Picto1.png";
import Picto2 from "./picto2/Picto2.png";
import Picto3 from "./picto3/Picto3.png";
import Picto4 from "./picto3/Picto4.png";
import Picto5 from "./picto3/Picto5.png";
import RadioCardL from "../../layouts/RadioCardL";

const StepThree = ({ onNext, onBack }) => {
  const [formData, setFormData] = useContext(HomeContext);
  const [isFormValid, setIsFormValid] = useState(false);
  const toast = useToast();

  useEffect(() => {
    const isValid = formData.housePosition && formData.superficieToiture && formData.orientationToiture;
    setIsFormValid(isValid);
  }, [formData]);

  const handleNextClick = () => {
    if (isFormValid) {
      onNext();
    } else {
      toast({
        title: "Champs manquants",
        description:
          "Veuillez remplir tous les champs obligatoires pour continuer.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleSuperficieToitureChange = (value) => {
    console.log(formData);
    setFormData((prevFormData) => ({
      ...prevFormData,
      superficieToiture: value,
    }));
  };

  const handleRadioChange = (name, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const {
    getRootProps: housePositionGroupProps,
    getRadioProps: housePositionRadioProps,
  } = useRadioGroup({
    name: "housePosition",
    defaultValue: formData.housePosition,
    onChange: (value) => handleRadioChange("housePosition", value),
  });

  const handleOccupationChange = (nextValue) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      occupationType: nextValue,
    }));
  };

  const housePositionOptions = [
    { label: "Maison isolee", value: "Maison isolee", icon: Picto3, iconWidth: "30px" },
    { label: "Maison mitoyenne", value: "Maison mitoyenne", icon: Picto4, iconWidth: "35px" },
    { label: "Maison encadree", value: "Maison encadree", icon: Picto5, iconWidth: "40px" },
  ];

  const handleOrientationToitureChange = (name, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  return (
    <Box width="full" px={20}>
      <Box display={"flex"} flexDirection={"row"}>
        <Box display={"flex"} flexDirection={"column"}>
          <Heading fontSize={"28px"} mb={1} fontWeight={"510"}>
            Architecture de la maison
          </Heading>
          <Text mb={8} color="#8C8C8C" fontWeight={"400"} fontSize="20px">
            Décrivez les détails concernant l'architecture de la maison.
          </Text>
        </Box>
        <Button
          ml={"50%"}
          w="120px"
          bgColor={"white"}
          color={"#30C9FF"}
          fontWeight={"600"}
          borderRadius={"8px"}
          padding={"8px, 16px, 8px, 21px"}
          onClick={onBack}
        >
          Back
        </Button>
      </Box>
      <Flex
        direction={{ base: "column", md: "row" }}
        border="1.8px solid"
        borderColor={"#F4F4F4"}
        p={{ base: "30px", md: "30px 86px" }}
        gap="71px"
        borderRadius="8px"
        bg="#FCFDFF"
        align="center"
        bgColor={"white"}
      >
        <Box display={"flex"} flexDirection={"column"}>
          <Box display={"flex"} flexDirection={"row"}>
            <Box display={"flex"} mr="20%" flexDirection={"column"}>
              <Heading
                fontSize={"20px"}
                fontWeight={"510"}
                color="gray.700"
                mb={1}
              >
                Toiture à Equiper
              </Heading>
              <Text fontSize="17px" fontWeight={"400"} color="#8C8C8C" mb={8}>
                Choisissez la toiture exact
              </Text>
            </Box>{" "}
            <Box display={"flex"} mr={""} flexDirection={"column"}>
              <Heading
                fontSize={"20px"}
                fontWeight={"510"}
                color="gray.700"
                mb={1}
              >
                Configuration de la toiture
              </Heading>

              <Text fontSize="17px" fontWeight="400" color="#8C8C8C" mb={8}>
                Saisissez les données précises de l'orientation
                <br /> et de l'inclinaison de la toiture
              </Text>
            </Box>
            <Box display={"flex"} ml={"7%"} flexDirection={"column"}>
              <Heading
                fontSize={"20px"}
                fontWeight={"510"}
                color="gray.700"
                mb={1}
              >
                Positionnement de la maison
              </Heading>

              <Text fontSize="17px" fontWeight="400" color="#8C8C8C" mb={8}>
                Choisissez le positionnement <br /> de la maison
              </Text>
            </Box>
          </Box>
          <Box display={"flex"} flexDirection={"row"}>
            <Box mr={"20px"} flex="1">
              <Box
                display={"flex"}
                w={["325px", "325px", "325px", "405px"]}
                h={"251px"}
                flexDirection={"column"}
                alignItems={"center"}
                gap={"10px"}
                borderRadius={"20px"}
                padding={"10px, 10px, 20px, 10px"}
                borderWidth={"1px"}
              >
                <IconCard icon={Picto1}></IconCard>
                <Text
                  fontSize="14px"
                  fontWeight="510"
                  // mb={"15px"}
                  color="#8C8C8C"
                  textAlign="left" // Aligns text to the left
                  flex="1" // Allows text to expand and take available space
                  textTransform="uppercase" // Makes text uppercase
                >
                  Superficie toiture à équiper en m2
                </Text>
                <Counter
                  initialValue={formData.superficieToiture}
                  onCountChange={(value) =>
                    setFormData({ ...formData, superficieToiture: value })
                  }
                />
              </Box>
            </Box>
            <Divider
              mr={"20px"}
              orientation="vertical"
              border={"1px solid"}
              h={"251px"}
              color={"#EAEAEA"}
            />
            <Box flex="1">
              <Box
                display={"flex"}
                w={["325px", "325px", "325px", "385px"]}
                mr={"20px"}
                h={"251px"}
                flexDirection={"column"}
                alignItems={"center"}
                gap={"10px"}
                borderRadius={"20px"}
                padding={"10px, 10px, 20px, 10px"}
                borderWidth={"1px"}
              >
                <IconCard icon={Picto1}></IconCard>
                <Text
                  fontSize="14px"
                  fontWeight="510"
                  // mb={"15px"}
                  color="#8C8C8C"
                  textAlign="left" // Aligns text to the left
                  flex="1" // Allows text to expand and take available space
                  textTransform="uppercase" // Makes text uppercase
                >
                  ORIENTATION TOITURE A EQUIPER
                </Text>
                <Select
                  mb={"20px"}
                  name="orientationToiture"
                  width={["313px", "313px", "263px", "363px"]}
                  height={"44px"}
                  fontWeight={"400"}
                  fontSize={"14px"}
                  color={formData.orientationToiture ? "black" : "#A7A7A7"}
                  gap={"302px"}
                  onChange={(e) =>
                    handleOrientationToitureChange(
                      "orientationToiture",
                      e.target.value
                    )
                  }
                  value={formData.orientationToiture}
                >
                  <option value="">Choose</option>
                  <option value="SUD">Sud</option>
                  <option value="SUD_EST">Sud-Est</option>
                  <option value="SUD_OUEST">Sud-Ouest</option>
                  <option value="OUEST">Ouest</option>
                  <option value="EST">Est</option>
                </Select>
              </Box>
            </Box>
            <Divider
              mr={"20px"}
              orientation="vertical"
              border={"1px solid"}
              h={"251px"}
              color={"#EAEAEA"}
            />
            <Box flex="1">
              <Stack {...housePositionGroupProps()} direction="column">
                {housePositionOptions.map((option) => (
                  <RadioCardL
                    iconWidth={option.iconWidth}
                    key={option.value}
                    {...housePositionRadioProps({ value: option.value })}
                    icon={option.icon}
                  >
                    {option.label}
                  </RadioCardL>
                ))}
              </Stack>
            </Box>
          </Box>
        </Box>
      </Flex>
      <Flex justifyContent="flex-end" my="3%">
        <Button
          w="120px"
          bgColor="#30C9FF"
          color="#FCFDFF"
          borderRadius="8px"
          padding="8px 16px"
          onClick={handleNextClick}
        >
          Next
        </Button>
      </Flex>
    </Box>
  );
};

export default StepThree;
